'use strict';

var ACC;
ACC.persistScroll = {
    timer: null,
    userHasScrolled: null,

    /** 
     * @returns {void}
     * @public
     */
    listenForUserScroll: function() {
        // update flag and unbind handler once called
        $(window).off('scroll', ACC.persistScroll.listenForUserScroll);
        ACC.persistScroll.userHasScrolled = true;
    },

    /** 
     * Saves the window scroll position to localStorage, this allows us to persist
     * scroll position across page refreshes without relying on global variables.
     * It is currently the most robust way to save scroll state given the inconsistent
     * implementation of the History API across browsers.
     * 
     * @param {string} scrollStorageKey – localStorage key
     * @returns {boolean|void}
     * @public
     */
    storeScrollPosition: function(scrollStorageKey) {
        if (!scrollStorageKey || typeof scrollStorageKey !== 'string') {
            return;
        }

        // try for localStorage API
        try {
            localStorage.setItem(scrollStorageKey, $(window).scrollTop());
            // here for consistent return
            return true;
        } catch (e) {
            return false;
        }
    },

    /** 
     * Removes the scrollStorageKey from localStorage.
     * 
     * @param {string} scrollStorageKey – localStorage key
     * @returns {boolean|void}
     * @public
     */
    clearScrollPosition: function(scrollStorageKey) {
        if (!scrollStorageKey || typeof scrollStorageKey !== 'string') {
            return;
        }

        // try for localStorage API
        try {
            localStorage.removeItem(scrollStorageKey);
            // here for consistent return
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * Retrieves the scroll position stored as the value of 'scrollStorageKey' 
     * from localStorage. Sets window scroll position using jQuery's .scrollTop method.
     * 
     * @param {string} scrollStorageKey – localStorage key
     * @returns {boolean|void}
     * @public
     */
    setScrollPosition: function(scrollStorageKey) {
        if (!scrollStorageKey || typeof scrollStorageKey !== 'string') {
            return;
        }

        // try for localStorage API
        try {
            var scrollPos = localStorage.getItem(scrollStorageKey);

            if (scrollPos) {
                // listen for user scroll on the PLP
                $(window).on('scroll', ACC.persistScroll.listenForUserScroll);
                window.clearTimeout(ACC.persistScroll.timer);

                /**
                 * setTimeout allows for the browser to make any DOM changes
                 * before manipulating scroll position. This is necessary when this function
                 * is called in the context of an AJAX call. 
                 */
                ACC.persistScroll.timer = window.setTimeout(function () {  
                    /**
                     * only restore scroll position if the user has not
                     * already expressed an intent to scroll.
                     */
                    if (!ACC.persistScroll.userHasScrolled) {
                        $(window).scrollTop(scrollPos);
                    }
                    localStorage.removeItem(scrollStorageKey);
                }, 250);
            }

            // here for consistent return
            return true;
        } catch (e) {
            return false;
        }
    }
};
